import { Location } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})
export class PreviewComponent { 
  constructor(
    public location: Location
  ) { }

  /**Go back to the route */
  back() {
    this.location.back();
  }

}
